import * as d3 from 'd3';

export default class RadarChart {
  constructor(root, options) {
    this.root = root
    this.initConfig(options)
  }

  initConfig(options) {
    this.cfg = {
      radius: 5,
      w: 250,
      h: 250,
      factor: 1,
      factorLegend: .85,
      levels: [0.0, 0.2, 0.4, 0.6, 0.8, 0.97 ],
      maxValue: 100,
      radians: 2 * Math.PI,
      opacityArea: 0.8,
      TranslateX: 85,
      TranslateY: 20,
      ExtraWidthX: 180,
      ExtraWidthY: 40,
      color: d3.color("#1E9F76")
    };
    for(var i in options){
      this.cfg[i] = options[i];
    }
  }

  draw (d) {
    var allAxis = (d[0].map((i) => i.axis ));
    var total = allAxis.length;

    var g  = this.initSVG()

    // draw axis
    this.drawAxis(g, allAxis, total)

    // draw data
    this.drawData(d, g, total)
  }

  initSVG () {
    var cfg = this.cfg

    return d3.select(this.root)
      .append("svg")
      .attr("viewBox", `0 0 ${cfg.w+cfg.ExtraWidthX} ${cfg.h+cfg.ExtraWidthY}`)
      .attr("preserveAspectRatio", "xMidYMid")
      .append("g")
      .attr("transform", "translate(" + cfg.TranslateX + "," + cfg.TranslateY + ")")
  }

  drawAxis(g, allAxis, total) {
    var cfg = this.cfg

    g.append("circle")
      .attr("cx",cfg.w/2)
      .attr("cy",cfg.w/2)
      .attr("r",cfg.w/2)
      .attr("fill","white")
      .attr("stroke-width",0)

    var axis = g.selectAll(".axis")
      .data(allAxis)
      .enter()
      .append("g")

    cfg.levels.forEach((level) => {
      axis.append("circle")
        .attr("cx", function(d, i){ return cfg.w/2 * (1-cfg.factor * level * Math.sin(i*cfg.radians/total))})
        .attr("cy", function(d, i){ return cfg.h/2 * (1-cfg.factor * level * Math.cos(i*cfg.radians/total))})
        .attr("r",1.3)
        .attr("fill",cfg.color)
        .attr("stroke-width",0)
    })

    axis.append("line")
      .attr("x1", cfg.w/2)
      .attr("y1", cfg.h/2)
      .attr("x2", function(d, i){ return cfg.w/2 * (1-cfg.factor*Math.sin(i*cfg.radians/total))})
      .attr("y2", function(d, i){ return cfg.h/2 * (1-cfg.factor*Math.cos(i*cfg.radians/total))})
      .style("stroke", cfg.color)
      .style("stroke-opacity", "0.75")
      .style("stroke-width", "0.5px");
    axis.append("text")
      .text(function(d){return d})
      .style("font-family", "sans-serif")
      .style("font-size", "11px")
      .style('fill', 'black')
      .attr("text-anchor", "middle")
      .attr("dy", "1.5em")
      .attr("transform", function(){return "translate(0, -12)"})
      .attr("text-anchor", (d, i) => {
        let x = Math.round(Math.sin(i*cfg.radians/total) * 100) / 100
        return (x == 0) ? 'middle' : (x > 0) ? 'end' : 'start'
      })
      .attr("x", function(d, i){return cfg.w/2*(1-cfg.factorLegend*Math.sin(i*cfg.radians/total))-20*Math.sin(i*cfg.radians/total);})
      .attr("y", function(d, i){return cfg.h/2*(1-Math.cos(i*cfg.radians/total))-13*Math.cos(i*cfg.radians/total);})
  }

  drawData(d, g, total) {
    var cfg = this.cfg

    d.forEach(function(y){
      var dataValues = [];
      g.selectAll(".nodes")
        .data(y, function(j, i){
          dataValues.push([
            cfg.w/2*(1-(parseFloat(Math.max(j.value, 0))/cfg.maxValue)*cfg.factor*Math.sin(i*cfg.radians/total)),
            cfg.h/2*(1-(parseFloat(Math.max(j.value, 0))/cfg.maxValue)*cfg.factor*Math.cos(i*cfg.radians/total))
          ]);
        });

      if ( dataValues.length > 0 )
        dataValues.push(dataValues[0]);

      g.selectAll(".area")
      .data([dataValues])
      .enter()
      .append("polygon")
      .style("stroke-width", "1.5px")
      .style("stroke", cfg.color)
      .style("fill", cfg.color)
      .style("fill-opacity", cfg.opacityArea)
      .attr("points",function(d) {
        var str="";
        for(var pti=0; pti<d.length; pti++){
          str=str+d[pti][0]+","+d[pti][1]+" ";
        }
        return str;
      });
    });
  }

}
